import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Link, Text } from '@paygreen/paygreen-ui';
import { LineKeyValue } from '../../../../components';
import {
    getDataFromObject,
    displayFrenchPhoneNumber,
} from '../../../../utils/tools';
import {
    CardInfo,
    EditModalIcon,
    administratorManagementList,
    representativeManagementList,
} from '../../shared';
import AdministratorManagementModal from './AdministratorManagementModal';

const AdministratorManagementCard = ({
    t,
    isLoading,
    setIsLoading,
    accountData,
    setAccountData,
    isShop,
    refresh,
}) => {
    const list = isShop
        ? administratorManagementList
        : representativeManagementList;

    return (
        <CardInfo
            isLoading={isLoading}
            title={t('admin.user.administratorInfos.title')}
            actionIcon={
                <EditModalIcon
                    title={t('admin.user.administratorInfos.editInfos')}
                >
                    <AdministratorManagementModal
                        accountData={accountData}
                        setAccountData={setAccountData}
                        setIsLoading={setIsLoading}
                        isShop={isShop}
                        refresh={refresh}
                    />
                </EditModalIcon>
            }
        >
            {list.map((item, index) => {
                const { name, value, type } = item;

                return (
                    <LineKeyValue
                        key={index}
                        hasUppercase={false}
                        keyLabel={t(
                            'admin.user.administratorInfos.' + name + 'Input',
                        )}
                        keyValue={
                            accountData &&
                            (type === 'phone'
                                ? displayFrenchPhoneNumber(
                                      getDataFromObject(value, accountData),
                                  )
                                : getDataFromObject(value, accountData)[0] +
                                  ' ' +
                                  getDataFromObject(value, accountData)[1])
                        }
                        textSize="xs"
                    >
                        {item.type === 'link' && (
                            <a
                                href={`mailto:${getDataFromObject(
                                    value,
                                    accountData,
                                )}`}
                            >
                                <Text textSize="xs">
                                    <Link colorTheme="secondary">
                                        {getDataFromObject(value, accountData)}
                                    </Link>
                                </Text>
                            </a>
                        )}
                    </LineKeyValue>
                );
            })}
        </CardInfo>
    );
};

AdministratorManagementCard.propTypes = {
    setIsLoading: PropTypes.func,
    isLoading: PropTypes.bool,
    accountData: PropTypes.object,
    setAccountData: PropTypes.func,
    isShop: PropTypes.bool,
    refresh: PropTypes.func,
};

AdministratorManagementCard.defaultProps = {
    isLoading: false,
    isShop: true,
};

export default withTranslation('common')(AdministratorManagementCard);
